import UpdatingBlock from './UpdatingBlock'
import { connect } from 'react-redux'
import { getStateByName } from './selectors'

const mapStateToProps = (state, { name = '', value = true, condition }) => ({
  condition: condition || getStateByName(state, name) === value
})

export default connect(mapStateToProps)(UpdatingBlock)
